// extracted by mini-css-extract-plugin
module.exports = {"header_title":"styles_header_title__HCoab","title_block":"styles_title_block__0TPsN"};